if (!window.customElements.get('instant-search')) {
  class InstantSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
      this.targetItems = document.querySelectorAll(this.getAttribute('data-target-items'));
    }

    connectedCallback() {
      this.input.addEventListener('keyup', () => this.searchItems());
    }

    searchItems() {
      // Accounting for dynamically created elements
      if (!this.targetItems.length) {
        this.targetItems = document.querySelectorAll(this.getAttribute('data-target-items'));
      }

      if (this.input.value != '') {
        this.targetItems.forEach((item) => {
          const searchAttribute = item.getAttribute('data-search-attribute').toLowerCase();
          item.classList.toggle('hidden', searchAttribute.indexOf(this.input.value.toLowerCase()) === -1);
        });
      } else {
        this.targetItems.forEach((item) => item.classList.remove('hidden'));
      }
    }
  }

  window.customElements.define('instant-search', InstantSearch);
}

if (!window.customElements.get('client-information')) {
  class ClientInformation extends HTMLElement {
    constructor() {
      super()
      this.userSelected = false;
      this.select = this.querySelector('[data-client-information-name]')
      this.emailInput = this.querySelector('[data-client-information-email]')
      this.nameProperty = document.querySelector('input[name="properties[Client Name]"]')
      this.emailProperty = document.querySelector('input[name="properties[Email Address]"]')
    }

    connectedCallback() {
      this.select.addEventListener('change', () => this.updateInputs())
      document.addEventListener('change', () => this.validateSelection())
    }

    validateSelection() {
      const submitButton = document.querySelector('[data-pdp-submit]')
      if (this.userSelected === false) { return; }
      submitButton.removeAttribute('disabled');
    }

    updateInputs() {
      const submitButton = document.querySelector('[data-pdp-submit]')
      const emailAddress = this.select.options[this.select.selectedIndex].getAttribute('data-email-address')
      this.emailInput.value = emailAddress
      this.emailProperty.value = emailAddress
      this.nameProperty.value = this.select.options[this.select.selectedIndex].value
      this.userSelected = true;
      submitButton.removeAttribute('disabled');
    }
  }

  window.customElements.define('client-information', ClientInformation);
}

if (!window.customElements.get('save-protocol-popup')) {
  class SaveProtocolPopup extends HTMLElement {
    constructor() {
      super()

      this.state = {
        new: false,
        type: null,
        price: null,
        products: [],
        listName: null,
        labelName: null,
        clientName: null,
        emailAddress: null,
        allergyInformation: null
      };

      this.clientSelect = document.querySelector('client-information [data-client-information-name]')
      this.emailAddress = document.querySelector('client-information [data-client-information-email]')
      this.protocolsList = this.querySelector('[data-save-protocol-popup-list]')
      this.newProtocol = this.querySelector('[data-save-protocol-popup-new]')
      this.newProtocolInput = this.querySelector('[data-save-protocol-popup-new-input]')
      this.newProtocolTrigger = this.querySelector('[data-save-protocol-popup-new-trigger]')
      this.saveTrigger = this.querySelector('[data-save-protocol-popup-submit]')
      this.backTrigger = this.querySelector('[data-save-protocol-popup-back-trigger]')
      this.popupHeading = this.querySelector('[data-save-protocol-popup-heading]')
      this.loading = this.querySelector('[data-save-protocol-popup-loading]')
      this.popupForm = this.querySelector('[data-save-protocol-popup-form]')
      this.popupSuccess = this.querySelector('[data-save-protocol-popup-success]')
    }

    connectedCallback() {
      this.wishlistPlusInit()
      this.saveTrigger.addEventListener('click', () => this.saveProtocol())
      this.newProtocolTrigger.addEventListener('click', () => {
        this.state.new = true
        this.updateListDisplay()
      })
      this.backTrigger.addEventListener('click', () => {
        this.state.new = false
        this.updateListDisplay()
      })
    }

    wishlistPlusInit() {
      if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
      }

      window.SwymCallbacks.push(onSwymLoadCallback.bind(this));

      /**
       * Wishlist Plus Callbacks
       */
      function onSwymLoadCallback(swat) {
        if (swat) {
          document.addEventListener('saveConfigurator', (event) => createList(swat, event.detail.listName, event.detail.labelName, event.detail.clientName, event.detail.allergyInformation, event.detail.emailAddress, event.detail.products));
          document.addEventListener('change', (event) => {
            this.selectList(event)
            this.updateList(event, swat)
          })
          swat.fetchLists({
            callbackFn: this.buildLists.bind(this),
          })
        } else {
          window.location.reload();
        }
      }

      /**
       * Create Wishlist Plus list
       * @param {Function} swat - Automatically generated Wishlist Plus wrapper function
       * @param {String} listName - Name for the list
       * @param {String} labelName - Name for the label
       * @param {String} clientName - Client name, will get added as an lprop on the list
       * @param {String} allergyInformation - Allergy information, will get added as an lprop on the list
       * @param {String} emailAddress - Email address, will get added as an lprop on the list
       * @param {Array} products - List of products to add to list
       */
      function createList(swat, listName, labelName, clientName, allergyInformation, emailAddress, products) {
        const listConfig = {
          lname: listName,
          lprops: {
            'Label Name': labelName ? labelName : '',
            'Client Name': clientName ? clientName : '',
            'Allergy Information': allergyInformation ? allergyInformation : '',
            'Email Address': emailAddress ? emailAddress : ''
          }
        }

        const fetchListsOnSuccess = function(lists) {
          const matchingList = lists.find((list) => list.lname === listName);

          if (matchingList) {
            swat.deleteList(matchingList.lid, deleteListOnSuccess, deleteListOnError);
          } else {
            swat.createList(listConfig, createListOnSuccess, createListOnError);
          }
        }

        const fetchListsOnError = function(error) {
          console.log('Error while fetching all Lists', error);
        }

        const createListOnSuccess = function(newList) {
          addProductsToList(swat, newList.lid, products);
        }

        const createListOnError = function(error) {
          console.log('Error while creating a List', error);
        }

        const deleteListOnSuccess = function(deletedList) {
          swat.createList(listConfig, createListOnSuccess, createListOnError);
        }

        const deleteListOnError = function(error) {
          console.log('Error while deleting a List', error);
        }

        swat.fetchLists({
          callbackFn: fetchListsOnSuccess,
          errorFn: fetchListsOnError
        });
      }

      /**
       * Add products to Wishlist Plus list
       * @param {Function} swat - Automatically generated Wishlist Plus wrapper function
       * @param {String} lid - List ID that the products should be added to
       * @param {Array} products - List of products to add to the list
       */
      function addProductsToList(swat, lid, products) {
        const onSuccess = function () {
          const savePopupHeading = document.querySelector('[data-save-protocol-popup-heading]');
          const savePopupLoading = document.querySelector('[data-save-protocol-popup-loading]');
          const savePopupSuccess = document.querySelector('[data-save-protocol-popup-success]')

          savePopupHeading.classList.remove('hidden');
          savePopupLoading.classList.add('hidden');
          savePopupSuccess.classList.remove('hidden');
        }

        const onError = function (error) {
          console.log('Error while adding products to the list', error);
        }

        swat.addProductsToList(lid, products, onSuccess, onError);
      }
    }

    buildLists(lists) {
      this.protocolsList.innerHTML = null
      if (lists.length) {
        let listsArray = lists

        if (this.emailAddress !== null) {
          listsArray = lists.filter((list) => list.lprops?.['Email Address'] === this.emailAddress.value)
        }

        listsArray.forEach((list) => {
          const listItem = document.createElement('li')

          listItem.classList.add('save-protocol-popup-list-item')
          listItem.setAttribute('data-search-item', '')
          listItem.setAttribute('data-search-attribute', `${list.lname} ${list.hasOwnProperty('lprops') ? list.lprops["Client Name"] : ''}` )

          listItem.innerHTML = `
            <label class="save-protocol-popup-list-item__button" for="protocol-${list.lid}">
                <input class="sr-only" type="radio" id="protocol-${list.lid}" name="Client Protocol" value="${list.lid}"
                data-lid="${list.lid}"
                data-list-name="${list.lname}"
                data-list-contents='${JSON.stringify(list.listcontents.map(({ du, empi, epi, qty, cprops }) => ({
                  du,
                  empi,
                  epi,
                  qty,
                  cprops,
                })))}'
                ${list.hasOwnProperty('lprops') ?
                  `data-list-client="${list.lprops["Client Name"]}" data-list-allergy="${list.lprops["Allergy Information"]}" data-list-email="${list.lprops["Email Address"]}" data-list-lable="${list.lprops["Label Name"]}"`
                  : ''
                }
                data-save-protocol-popup-list-item>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.95 10L8.65 12.7L14.05 7.3M19 10C19 14.9705 14.9705 19 10 19C5.02943 19 1 14.9705 1 10C1 5.02943 5.02943 1 10 1C14.9705 1 19 5.02943 19 10Z" stroke="black" stroke-width="2"></path>
                </svg>
                <span class="save-protocol-popup-list-item__unselected"></span>
                <div class="save-protocol-popup-list-item__content">
                  <strong>${list.lname}</strong>
                  ${list.hasOwnProperty('lprops') ?
                    `<span>${list.lprops["Client Name"]}</span>`
                    : ''
                  }
                </div>
            </label>
          `

          this.protocolsList.appendChild(listItem)
        })
      }
    }

    updateListDisplay() {
      this.protocolsList.classList.toggle('hidden', this.state.new)
      this.newProtocolTrigger.classList.toggle('hidden', this.state.new)
      this.newProtocol.classList.toggle('hidden', !this.state.new)
      this.backTrigger.classList.toggle('hidden', !this.state.new)

      this.state.listName = null
      this.state.labelName = null
      this.state.allergyInformation = null
      this.state.products = []
    }

    selectList(event) {
      if (!event.target.hasAttribute('data-save-protocol-popup-list-item')) { return }

      this.state.listName = event.target.getAttribute('data-list-name')
      this.state.labelName = event.target.getAttribute('data-list-label')
      this.state.allergyInformation = event.target.getAttribute('data-list-allergy')
      this.state.emailAddress = event.target.getAttribute('data-list-email')
      this.state.clientName = event.target.getAttribute('data-list-client')
      this.state.products = JSON.parse(event.target.getAttribute('data-list-contents'))
    }

    updateList(event, swat) {
      if (!event.target.hasAttribute('data-client-information-name')) { return }

      swat.fetchLists({
        callbackFn: this.buildLists.bind(this),
      })
    }

     /**
     * Pass formatted data from this.state to Wishlist Plus to create and save a new list
     */
     saveProtocol() {
      this.state.listName = this.state.new ? this.newProtocolInput.value : this.state.listName;
      if (this.state.listName === null) { return }

      this.popupHeading.classList.add('hidden');
      this.popupForm.classList.add('hidden');
      this.loading.classList.remove('hidden');
      this.popupHeading.innerText = this.popupHeading.getAttribute('data-success-text');

      this.state.products.push({
        du: window.location.href.split('?')[0],
        empi: parseInt(this.saveTrigger.getAttribute('data-product-id'), 10),
        epi: this.closest('.product').querySelector('input[name="id"]').value,
        qty: 1,
        cprops: {
          type: 'retail'
        }
      })

      const detail = {
        listName: this.state.listName,
        labelName: this.state.labelName,
        clientName: this.state.clientName ? this.state.clientName : this.clientSelect.value,
        allergyInformation: this.state.allergyInformation,
        emailAddress: this.state.emailAddress ? this.state.emailAddress : this.clientSelect.options[this.clientSelect.selectedIndex].getAttribute('data-email-address'),
        products: this.state.products
      }

      document.dispatchEvent(new CustomEvent('saveConfigurator', { detail }));
    }
  }

  window.customElements.define('save-protocol-popup', SaveProtocolPopup)
}

if (!window.customElements.get('line-item-main-product-price')) {
  class LineItemMainProductPrice extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.updatePrice();
    }

    updatePrice() {
      const wrapper = this.closest('[data-line-item-wrapper]');
      if (!wrapper) { return; }
      const price = wrapper.querySelector('[data-line-item-price]');
      price.innerText = this.innerText;
    }
  }

  window.customElements.define('line-item-main-product-price', LineItemMainProductPrice);
}

if (!window.customElements.get('main-cart')) {
  class MainCart extends HTMLElement {
    constructor() {
      super();
      this.submitButton = this.querySelector('button[type="submit"]');
    }

    connectedCallback() {
      this.validateCartItems();
      this.submitButton.addEventListener('click', (event) => this.setAddress(event));
    }

    async setAddress(event) {
      event.preventDefault();
      const addresses = this.getAttribute('data-addresses') ? JSON.parse(this.getAttribute('data-addresses')) : [];

      if (addresses.length) {
        event.preventDefault();
        const cart = await this.getCart();
        const clientName = cart?.attributes['Client Name'];

        if (clientName) {
          const matchingAddress = addresses.find((address) => address.name === clientName);

          if (matchingAddress) {
            const addAddressQuery = await storefront.fetch(await cartDeliveryAddressesAdd(matchingAddress.id, cart.token));
            await storefront.fetch(await cartDeliveryAddressesUpdate(matchingAddress.name, cart.token, addAddressQuery?.cartDeliveryAddressesAdd?.cart?.delivery?.addresses));
          }
        }
      }

      window.location.href = '/checkout';
    }

    async getCart() {
      const requestOptions = {
        method: 'GET',
        redirect: 'follow',
        headers: {
          'Content-Type': 'application/json',
        }
      };

      return await fetch('/cart.json', requestOptions)
        .then((response) => {
          return response.json()
        })
        .then((result) => {
          return result
        })
        .catch((error) => {
          return error
        });
    }

    async validateCartItems() {
      const cartData = await fetch('/cart.json', {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'xmlhttprequest'
        }
      })
      .then(response => response.json())
      .then(response => { return response; })
      .catch((error) => {console.log(error)});

      const childProducts = cartData?.items?.filter((item) => item.properties._type && item.properties._type !== 'main');

      if (!childProducts.length) { return; }

      const itemsToUpdate = [];

      childProducts.forEach((childProduct) => {
        const matchingParent = cartData.items.find((item) => item.properties._type === 'main' && item.properties._protocol === childProduct.properties._protocol);

        if (matchingParent) {
          const targetQuantity = (matchingParent.quantity * parseInt(childProduct.properties._quantity));

          if (childProduct.quantity !== targetQuantity) {
            itemsToUpdate.push({
              key: childProduct.key,
              quantity: targetQuantity
            })
          }
        } else if (!matchingParent) {
          itemsToUpdate.push({
            key: childProduct.key,
            quantity: 0
          });
        }
      });

      if (!itemsToUpdate.length) { return; }

      let updates = Object.fromEntries(itemsToUpdate?.map((item) => {
        return [
          item.key, item.quantity
        ]
      }));

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest'
        },
        body: JSON.stringify({ updates })
      })
      .then(response => response.json())
      .then((res) => {
        if (res.status === 422) {
          alert(res.message);
        } else {
          window.location.reload();
        }
       })
      .catch((error) => {console.log(error)});
    }
  }

  window.customElements.define('main-cart', MainCart);
}

/**
 * @desc Shopify storefront request
 */
const storefront = new class StoreFront {
  constructor () {
    this.STOREFRONT_API_TOKEN = window.storefront?.apiToken
    this.STOREFRONT_API_VERSION = window.storefront?.apiVersion
    this.STORE = window.storefront?.store
    this.invalidCredentials = false

    if (
      typeof this.STORE !== 'undefined' &&
      typeof this.STOREFRONT_API_TOKEN !== 'undefined' &&
      typeof this.STOREFRONT_API_VERSION !== 'undefined' &&
      this.STOREFRONT_API_TOKEN !== null
    ) { return }

    console.warn('STOREFRONT_API_TOKEN, STOREFRONT_API_VERSION, or STORE is not set.')
    this.invalidCredentials = true
  }

  async fetch (graphqlData) {
    if (this.invalidCredentials) { return null }

    const fetchHeaders = new Headers() // eslint-disable-line
    fetchHeaders.append('x-shopify-storefront-access-token', this.STOREFRONT_API_TOKEN)
    fetchHeaders.append('Content-Type', 'application/json')

    const requestOptions = {
      method: 'POST',
      headers: fetchHeaders,
      body: graphqlData
    }

    const response = await fetch(`https://${this.STORE}/api/${this.STOREFRONT_API_VERSION}/graphql.json`, requestOptions)
      .then(response => response.json())

    if (response.errors) {
      console.error(response.errors)
      return null
    }

    return response.data
  }
}()

/**
 * @desc Add a delivery address to the cart
 * @param {String} id -> ID of the address that should be active
 * @param {String} cartToken -> Cart token
 */
const cartDeliveryAddressesAdd = async (id, cartToken) => {
  const graphQlVariables = {
    "id": `gid://shopify/Cart/${cartToken}`,
    "addresses": [
      {
        "selected": true,
        "address": {
          "copyFromCustomerAddressId": `gid://shopify/MailingAddress/${id}?model_name=CustomerAddress`
        }
      }
    ]
  }

  const graphQlQuery = `
    mutation CartDeliveryAddressesAdd($id: ID!, $addresses: [CartSelectableAddressInput!]!) {
      cartDeliveryAddressesAdd(cartId: $id, addresses: $addresses) {
        userErrors {
          message
          code
          field
        }
        warnings {
          message
          code
          target
        }
        cart {
          id
          delivery {
            addresses {
              id
              selected
              oneTimeUse
              address {
                ... on CartDeliveryAddress {
                  firstName
                  lastName
                  company
                  address1
                  address2
                  city
                  provinceCode
                  zip
                  countryCode
                }
              }
            }
          }
        }
      }
    }
  `

  return JSON.stringify({
    query: graphQlQuery,
    variables: graphQlVariables
  })
}

/**
 * @desc Update the selected delivery address
 * @param {String} matchingAddressName -> Name of the address that should be active
 * @param {String} cartToken -> Cart token
 * @param {Array} cartAddresses -> Available addresses on the cart
 */
const cartDeliveryAddressesUpdate = async (matchingAddressName, cartToken, cartAddresses) => {
  const graphQlVariables = {
    "id": `gid://shopify/Cart/${cartToken}`,
    "addresses": cartAddresses.map((address) => {
      const clientName = `${address.address.firstName} ${address.address.lastName}`
      return {
        "id": address.id,
        "selected": clientName === matchingAddressName
      }
    })
  }

  const graphQlQuery = `
    mutation CartDeliveryAddressesUpdate($id: ID!, $addresses: [CartSelectableAddressUpdateInput!]!) {
      cartDeliveryAddressesUpdate(cartId: $id, addresses: $addresses) {
        userErrors {
          message
          code
          field
        }
        warnings {
          message
          code
          target
        }
        cart {
          id
          delivery {
            addresses {
              id
              selected
              oneTimeUse
              address {
                ... on CartDeliveryAddress {
                  firstName
                  lastName
                  company
                  address1
                  address2
                  city
                  provinceCode
                  zip
                  countryCode
                }
              }
            }
          }
        }
      }
    }
  `

  return JSON.stringify({
    query: graphQlQuery,
    variables: graphQlVariables
  })
}

if (!window.customElements.get('address-form-email-company')) {
  class AddressFormEmailCompany extends HTMLElement {
    constructor() {
      super();
      this.fakeEmailInput = this.querySelector('[data-fake-email-input]');
      this.fakeCompanyInput = this.querySelector('[data-fake-company-input]');
      this.companyInput = this.querySelector('[data-company-input]');
    }

    connectedCallback() {
      this.fakeEmailInput.addEventListener('keyup', () => this.updateCompanyInput());
      this.fakeCompanyInput.addEventListener('keyup', () => this.updateCompanyInput());
    }

    /**
     * Update real company input with the combined values of the fake inputs
     */
    updateCompanyInput() {
      this.companyInput.value = `${this.fakeCompanyInput.value}|${this.fakeEmailInput.value}`;
    }
  }

  window.customElements.define('address-form-email-company', AddressFormEmailCompany);
}

/**
 * Check inventory levels and return an error popup if variant is unavailable.
 * @param {Array} products - Array of objects used to validate variants. Ex. [{handle: 'handle', variantId: 123456789}, {handle: 'handle2', variantId: 12345678}]
 * @param {String} editButtonLink - Link for the edit button
 */
async function checkInventoryLevels(products, editButtonLink) {
  const inventoryLevels = [];
  const inventoryLevelsPopupTrigger = document.querySelector('[data-inventory-levels-popup-trigger]');
  const inventoryLevelsPopupContent = document.querySelector('[data-inventory-levels-popup-content]');
  const inventoryLevelsPopupEditButton = document.querySelector('[data-inventory-levels-popup-edit]');

  for (let index = 0; index < products.length; index++) {
    const product = products[index];

    const productData = await fetch(`/products/${product.handle}.js`, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      }
    })
    .then(response => response.json())
    .then(response => { return response; })
    .catch((error) => {console.log(error)});

    const matchingVariant = productData?.variants.find((variant) => variant.id === parseInt(product.variantId));

    inventoryLevels.push({
      name: product.title,
      available: matchingVariant ? matchingVariant.available : false
    })
  }

  const soldoutItems = inventoryLevels.filter((item) => item.available === false);

  if (!soldoutItems.length) { return; }

  const soldoutItemNames = soldoutItems.map((item) => {
    return item.name
  })

  if (inventoryLevelsPopupTrigger) {
    inventoryLevelsPopupTrigger.click();
  }

  if (inventoryLevelsPopupContent) {
    inventoryLevelsPopupContent.innerText = `${soldoutItemNames.join(' and ')} ${soldoutItemNames.length === 1 ? 'is' : 'are'} no longer available.`
  }

  if (inventoryLevelsPopupEditButton) {
    inventoryLevelsPopupEditButton.setAttribute('href', editButtonLink);
    inventoryLevelsPopupEditButton.classList.toggle('hidden', !editButtonLink);
  }

  return soldoutItems;
}

if (!window.customElements.get('address-form')) {
  class AddressForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
    }

    connectedCallback() {
      this.form.addEventListener('submit', (event) => this.formSubmission(event));
    }

    /**
     * Stop form redirect and handle address creation submission
     * @param {Event} event - Form submission event
     */
    async formSubmission(event) {
      if (window.location.href.indexOf('/products/') === -1) { return; }

      event.preventDefault();

      try {
        const url = this.form.getAttribute('action');
        const formData = new FormData(this.form);
        const response = await fetch(url, {
          method: 'POST',
          body: formData
        });

        if (!response.ok) {
          throw new Error(`Response status: ${response.status}`);
        }

        const clientNameSelect = document.querySelector('[data-configurator-client-name]') || document.querySelector('[data-client-information-name]');
        const newOption = document.createElement('option');
        const optionValue = `${formData.get('address[first_name]')} ${formData.get('address[last_name]')}`;
        const optionLabels = Array.from(clientNameSelect.options).map((opt) => opt.value);
        const alreadyHasOption = optionLabels.includes(optionValue);

        if (!alreadyHasOption) {
          newOption.setAttribute('data-email-address', formData.get('address[company]').split('|')[1])
          newOption.value = optionValue;
          newOption.innerHTML = optionValue;
          clientNameSelect.appendChild(newOption);
          clientNameSelect.value = optionValue;
          clientNameSelect.dispatchEvent(new Event('change'));
          document.body.click();
        }

      } catch (error) {
        console.error(error.message);
      }
    }
  }

  window.customElements.define('address-form', AddressForm);
}